import { render, staticRenderFns } from "./CommunityGroupForm.vue?vue&type=template&id=a8d7b022&"
import script from "./CommunityGroupForm.vue?vue&type=script&lang=js&"
export * from "./CommunityGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports